import * as React from 'react';
import { ProductSheetAppointmentDetails } from '../../../../../../config/order-tracker-new-common/constants'
import { ProductDetailsSection } from '../product-details-section';
import StaticData, { StaticDataGroup } from 'ted-ui/build/StaticData';
import Spacing from '@able/react/dist/Spacing';
import {IAppointmentDetailsProps} from '@applications/order-tracker/config/order-tracker-new-common/types'
import { productAppointmentInformationBusinessRules } from '@applications/order-tracker/config/order-tracker-new-common/order-products-utils';
import { useResize } from 'ted-ui/build/util';

const AppointmentInformation = ({appointmentDetails}: IAppointmentDetailsProps) => {
  const { showAppointmentStatus } =
    productAppointmentInformationBusinessRules(appointmentDetails);

  const [columnSize, setColumnSize] = React.useState(2);
  useResize((size) => {
      if (size === 'xs') {
        setColumnSize(1);
      } else {
        setColumnSize(2);
      }
    }, []);

  const getGroupOfDescsAppointmentStatus = (): React.ReactNode => (
        <StaticData
            id="static-data-test"
            name={ProductSheetAppointmentDetails.AppointmentStatus}
            value={appointmentDetails.status}
          />
  );

  const getGroupOfDescsAppointmentDate = (): React.ReactNode => (
          <StaticData
            id="static-data-test"
            name={ProductSheetAppointmentDetails.AppointmentDate}
            value={appointmentDetails.date}
          />
  );

  const getGroupOfDescs = (): React.ReactNode =>
  (
    <StaticDataGroup config={{
      horizontalColumn: columnSize
    }} id="appointment-details-group-data">
        {showAppointmentStatus() && getGroupOfDescsAppointmentStatus()}
        {getGroupOfDescsAppointmentDate()}
    </StaticDataGroup>
  );
  return (
     <Spacing top="spacing3x">
      <ProductDetailsSection
        title={ProductSheetAppointmentDetails.Title}
        descriptionGroup={getGroupOfDescs()}
      />
      </Spacing>
  );
};

export default AppointmentInformation;
